<div class="history-container">
  <!-- History Table -->
  <div class="history-table" *ngIf="history.length > 0">
    <table mat-table [dataSource]="history">
      <!-- Date Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let entry">{{ entry.date | date:'MM/dd/yyyy h:mm a' }}</td>
      </ng-container>

      <!-- Type Column -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let entry">
          <mat-chip [ngClass]="getTypeClass(entry.type)">
            {{ entry.type }}
          </mat-chip>
        </td>
      </ng-container>

      <!-- User Column -->
      <ng-container matColumnDef="user">
        <th mat-header-cell *matHeaderCellDef>User</th>
        <td mat-cell *matCellDef="let entry">{{ entry.user }}</td>
      </ng-container>

      <!-- Attribute Column -->
      <ng-container matColumnDef="attribute">
        <th mat-header-cell *matHeaderCellDef>Attribute</th>
        <td mat-cell *matCellDef="let entry">{{ entry.attribute }}</td>
      </ng-container>

      <!-- Old Value Column -->
      <ng-container matColumnDef="oldValue">
        <th mat-header-cell *matHeaderCellDef>Old Value</th>
        <td mat-cell *matCellDef="let entry">{{ entry.oldValue }}</td>
      </ng-container>

      <!-- New Value Column -->
      <ng-container matColumnDef="newValue">
        <th mat-header-cell *matHeaderCellDef>New Value</th>
        <td mat-cell *matCellDef="let entry">{{ entry.newValue }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <!-- Empty State -->
  <div class="empty-history" *ngIf="history.length === 0">
    <mat-icon>history</mat-icon>
    <p>No history available</p>
  </div>
</div>
